import HeaderAffida from "../../header/HeaderAffida";
import React from "react";

export default function OpenLayout({
                                       children,
                                   }: {
    children: React.ReactNode;
}) {
    return (
            <div>
                <HeaderAffida />
            <main>{children}</main>
            </div>
            );
}
